// extracted by mini-css-extract-plugin
export default {"stackIconContainer":"StackIconEditor_stackIconContainer__4Ni9n","stackIcon":"StackIconEditor_stackIcon__IkZiP"};